import { render, staticRenderFns } from "./period-add-or-update.vue?vue&type=template&id=c04a82cc"
import script from "./period-add-or-update.vue?vue&type=script&lang=js"
export * from "./period-add-or-update.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports